import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Input,
} from "@chakra-ui/react";
import { Formik, Form } from "formik";

const CorporateOrganizationForm = ({ handleNext }) => {
  const initialValues = {
    corporateInfo: {
      nameOfOrganzation: "",
      address: "",
      state: "",
      city: "",
      postalAddress: "",
      phoneNumber: "",
      emailAddress: "",
      typeOfBussiness: "",
      productOrService: "",
      annualTurnover: 0,
      noOfEmployees: 0,
      faxNo: 0,
      yearOfIncorporation: "",
      rcNo: 0,
      liability: "",
      itInterestArea: 0,
      interestGroups: 0,
    },
  };

  const handleSubmit = (values) => {
    handleNext(values);
  };

  return (
    <Box p={5} bg="#fff" borderRadius="md" boxShadow="md">
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({ values, errors, touched, handleBlur, handleChange }) => (
          <Form>
            <Grid
              templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
              gap={4}
              mt={5}
              w={"98%"}
            >
              {[
                { name: "nameOfOrganzation", label: "Organization Name" },
                { name: "address", label: "Office Address" },
                { name: "state", label: "State" },
                { name: "city", label: "City" },
                { name: "postalAddress", label: "Postal Address" },
                { name: "phoneNumber", label: "Phone Number" },
                { name: "emailAddress", label: "Email Address", type: "email" },
                { name: "typeOfBussiness", label: "Type of Business" },
                { name: "productOrService", label: "Product or Service" },
                { name: "annualTurnover", label: "Annual Turnover", type: "number" },
                {
                  name: "noOfEmployees",
                  label: "Number of Employees",
                  type: "number",
                },
                { name: "faxNo", label: "Fax Number", type: "number" },
                { name: "yearOfIncorporation", label: "Year of Incorporation" },
                { name: "rcNo", label: "RC Number", type: "number" },
                { name: "liability", label: "Liability Type" },
                {
                  name: "itInterestArea",
                  label: "IT Interest Area",
                  type: "number",
                },
                {
                  name: "interestGroups",
                  label: "Interest Groups",
                  type: "number",
                },
              ].map(({ name, label, type = "text" }) => (
                <GridItem key={name}>
                  <FormControl
                    isInvalid={
                      errors?.corporateInfo?.[name] &&
                      touched?.corporateInfo?.[name]
                    }
                  >
                    <FormLabel fontSize="16px">{label}</FormLabel>
                    <Input
                      name={`corporateInfo.${name}`}
                      placeholder="Enter Here"
                      type={type}
                      fontSize="small"
                      bg="#F3F3F3"
                      borderRadius="8px"
                      focusBorderColor="#ffffff"
                      borderColor="#FFFFFF"
                      _placeholder={{ color: "#B4B1B1" }}
                      _hover={{ borderColor: "#FFFFFF" }}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      value={values.corporateInfo[name]}
                    />
                    <FormErrorMessage>
                      {errors?.corporateInfo?.[name]}
                    </FormErrorMessage>
                  </FormControl>
                </GridItem>
              ))}
            </Grid>

            <Flex justifyContent="center" gap={6} mt={10}>
              <Button bg="#A6A6A6" color="#FFFFFF" w="200px">
                Cancel
              </Button>
              <Button bg="#23A455CC" color="#FFFFFF" w="200px" type="submit">
                Next
              </Button>
            </Flex>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default CorporateOrganizationForm;
